import { FC } from 'react';
import clsx from 'clsx';
import { ActivityItem } from '~/domain/activity/components/ActivityItem/ActivityItem';
import { Pagination } from '~/application/components/Pagination/Pagination';
import { useActivityItemList, Props } from './useActivityItemList';
import styles from './ActivityItemList.module.css';

export const ActivityItemList: FC<Props> = (props) => {
  const { activities, cols, page, pageTotal, onChangePage } =
  useActivityItemList(props);

  return (
    <div>
      <div className={clsx(styles.list, cols === 3 && styles.cols3)}>
        {activities.map((activity) => {
          return (
            <div key={activity.id}>
              <ActivityItem activity={activity} />
            </div>);

        })}
      </div>
      {page !== undefined && page > 1 && pageTotal !== undefined &&
      <div className={styles.pagination}>
          <Pagination
          page={page}
          pageTotal={pageTotal}
          onChangePage={onChangePage} />

        </div>}

    </div>);

};